import { $$ } from '../_utils'

const PROGRESS_BAR_SELECTOR = '.js-progress'

class ProgressBar {
  static getProgress = struct => {
    const { $progressBar } = struct

    return {
      ...struct,
      percentage: $progressBar.dataset.percentage |> parseInt,
    }
  }

  static setProgress = struct => {
    const { $progressBar, percentage } = struct
    $progressBar.style.setProperty('transform', `scaleX(${percentage / 100})`)

    return struct
  }

  static init = $progressBar => {
    const struct = { $progressBar }

    struct |> this.getProgress |> this.setProgress
  }
}

window.addEventListener('load', () => {
  const $$progressBars = $$(PROGRESS_BAR_SELECTOR)

  $$progressBars.forEach($progressBar => {
    ProgressBar.init($progressBar)
  })
})
